import { useState, useEffect } from "react";
import type { AlertLevel, Escalation } from "../types/game";
import { TTSToggle } from "./TTSToggle";
import { EscalationMeter } from "./EscalationMeter";

interface Props {
  alertLevel: AlertLevel;
  shipName: string;
  missionStartMs: number;
  baseStardate: number;
  escalation?: Escalation;
}

function formatStardate(base: number, startMs: number): string {
  const elapsedDays = (Date.now() - startMs) / 86_400_000;
  return (base + elapsedDays * 10).toFixed(1);
}

export function AlertStatus({ alertLevel, shipName, missionStartMs, baseStardate, escalation }: Props) {
  const [stardate, setStardate] = useState(() => formatStardate(baseStardate, missionStartMs));

  useEffect(() => {
    const id = setInterval(() => {
      setStardate(formatStardate(baseStardate, missionStartMs));
    }, 6000); // update every ~6 seconds (0.1 stardate units/day ≈ negligible drift)
    return () => clearInterval(id);
  }, [baseStardate, missionStartMs]);

  const alertConfig = {
    normal: { label: "CONDITION GREEN", className: "alert-normal" },
    yellow: { label: "YELLOW ALERT",    className: "alert-yellow" },
    red:    { label: "RED ALERT",       className: "alert-red" },
  };

  const config = alertConfig[alertLevel] ?? alertConfig.normal;

  return (
    <div className={`alert-status-bar ${config.className}`}>
      <div className="alert-label">{config.label}</div>
      <div className="ship-name">{shipName}</div>
      {escalation && <EscalationMeter escalation={escalation} />}
      <div className="stardate">STARDATE {stardate}</div>
      <TTSToggle />
    </div>
  );
}
